import { Box, getColoursFromTheme, Stack } from 'src/viewLayer/components/DesignSystem'
import TrackableLink from 'src/viewLayer/components/shared/TrackableLink'
import devices from 'src/viewLayer/styling/mixins/mediaQueries'
import zIndex from 'src/viewLayer/styling/mixins/zIndex'
import styled from 'styled-components'

const LoginPasswordPageContainer = styled.div`
  background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.foregroundColor};
  height: 100%;
  min-height: calc(100% - 4rem);

  @media only screen and ${devices.fromsmall} {
    background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.backgroundColor};
  }
`

const FormContainer = styled(Stack)`
  margin: 0 auto;
  width: 100%;

  @media only screen and ${devices.fromxxsmall} {
    width: 20rem;
  }
  @media only screen and ${devices.fromxsmall} {
    width: 21rem;
  }
`

const InputFrame = styled(Box)`
  padding: 2.5rem 0 0 0;

  @include from-small {
    padding: 3rem 0 0 0;
  }
`

const ActionsContainer = styled(Box)`
  display: block;
  margin: 2rem auto 0;
  width: 100%;

  @media only screen and ${devices.fromsmall} {
    margin: 1.5rem auto 0;
  }

  @media only screen and ${devices.frommedium} {
    margin: 2rem auto 0;
  }
`

const KeysContainer = styled(Box)`
  left: -50%;
  top: -6.25rem;
  z-index: ${zIndex.back};
`

const BigLockContainer = styled(Box)`
  right: -33%;
  top: 17.188rem;
  z-index: ${zIndex.decorationBack};
`

const ForgotPasswordTrackableLink = styled(TrackableLink)`
  align-self: flex-end;
  margin-top: 0.625rem;
`
export {
  ActionsContainer,
  BigLockContainer,
  ForgotPasswordTrackableLink,
  FormContainer,
  InputFrame,
  KeysContainer,
  LoginPasswordPageContainer,
}
